import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Blend_Switches from './Blend-switch';
import BlendCalculationMode from './BlendCalculationMode';
import Blend_slider from './Blend-slider';
import TextField from '@material-ui/core/TextField';
import { RatioType, FuelConstant, InfoType, PropertyType } from '../../services/bunkermaster/Settings';
import { ViscosityCalculationService } from '../../services/bunkermaster/ViscosityCalculationService';
import Blending from '../../services/bunkermaster/BlendingService';
import Ratio from '../../services/bunkermaster/Ratio';
import { MathFormula } from '../../services/bunkermaster/Math';
import { Approximates } from '../../services/bunkermaster/FuelMath';

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";
import { set } from 'lodash';
import { ToastError } from '../../services/ToastMsg';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(Parameter, Unit, Fuel1Name,
    Fuel1, Fuel2Name, Fuel2, TargetName, Target, BlendName, Blend, decimalPts) {
    return {
        Parameter, Unit, Fuel1Name,
        Fuel1, Fuel2Name, Fuel2, TargetName, Target, BlendName, Blend, decimalPts
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },

    btn3: {

        marginLeft: '40px !important',
        padding: '8px 15px',

    },
    textstyles: {
        color: '#ff4717'
    }
}));

function BlendCalculation() {
    const classes = useStyles();
    const initialInputState = {
        densityFuel1: '',
        densityFuel2: '',
        densityTarget: '',
        densityBlend: '',
        fpFuel1: '',
        fpFuel2: '',
        fpTarget: '',
        fpBlend: '',
        visFuel1: '',
        visFuel2: '',
        visTarget: '',
        visBlend: '',
        visTempFuel1: '50',
        visTempFuel2: '40',
        visTempTarget: '50',
        visTempBlend: '',
        mcFuel1: '',
        mcFuel2: '',
        mcTarget: '',
        mcBlend: '',
        sulFuel1: '',
        sulFuel2: '',
        sulTarget: '',
        sulBlend: '',
        ashFuel1: '',
        ashFuel2: '',
        ashTarget: '',
        ashBlend: '',
        sodFuel1: '',
        sodFuel2: '',
        sodTarget: '',
        sodBlend: '',
        vanFuel1: '',
        vanFuel2: '',
        vanTarget: '',
        vanBlend: '',
        aluFuel1: '',
        aluFuel2: '',
        aluTarget: '',
        aluBlend: '',
    };

    // Test inputs
    // const initialInputState = {
    //     densityFuel1: "721.0",
    //     densityFuel2: "777.0",
    //     densityTarget: "767.0",
    //     densityBlend:'',
    //     fpFuel1: "67",
    //     fpFuel2: "55",
    //     fpTarget: "64",
    //     fpBlend: '',
    //     visFuel1: "555.0",
    //     visFuel2: "612.0",
    //     visTarget: "712.0",
    //     visBlend: '',
    //     visTempFuel1: "50",
    //     visTempFuel2: "40",
    //     visTempTarget: "50",
    //     visTempBlend: '',
    //     mcFuel1: "54.0",
    //     mcFuel2: "65.0",
    //     mcTarget: "77.0",
    //     mcBlend: '',
    //     sulFuel1: "87.00",
    //     sulFuel2: "99.00",
    //     sulTarget: "99.00",
    //     sulBlend: '',
    //     ashFuel1: "35.00",
    //     ashFuel2: "66.00",
    //     ashTarget: "76.00",
    //     ashBlend: '',
    //     vanFuel1: "154",
    //     vanFuel2: "344",
    //     vanTarget: "552",
    //     vanBlend: '',
    //     sodFuel1: "345",
    //     sodFuel2: "666",
    //     sodTarget: "712",
    //     sodBlend: '',
    //     aluFuel1: "666",
    //     aluFuel2: "777",
    //     aluTarget: "888",
    //     aluBlend: '',
    // };

    const [valid, setvalid] = React.useState("none")
    const [value, setValue] = React.useState(0);
    const [calcFields, setCalcFields] = React.useState({ calcmethod: "blend-targets" }); // Radio button
    const [{
        densityFuel1,
        densityFuel2,
        densityTarget,
        densityBlend,
        fpFuel1,
        fpFuel2,
        fpTarget,
        fpBlend,
        visFuel1,
        visFuel2,
        visTarget,
        visBlend,
        visTempFuel1,
        visTempFuel2,
        visTempTarget,
        visTempBlend,
        mcFuel1,
        mcFuel2,
        mcTarget,
        mcBlend,
        sulFuel1,
        sulFuel2,
        sulTarget,
        sulBlend,
        ashFuel1,
        ashFuel2,
        ashTarget,
        ashBlend,
        sodFuel1,
        sodFuel2,
        sodTarget,
        sodBlend,
        vanFuel1,
        vanFuel2,
        vanTarget,
        vanBlend,
        aluFuel1,
        aluFuel2,
        aluTarget,
        aluBlend,
    }, setState] = React.useState(initialInputState);
    const [fuelInput, setFuelInput] = React.useState({ fuel1: '', fuel2: '' }); // Fuel input
    const [fuelOutput, setFuelOutput] = React.useState({ fuel1: '', fuel2: '' });;  // Calculated fuel output.
    const [inputSlider, setInputSlider] = React.useState(false); //true - Weight; Toggle the slider
    const [outputSlider, setOutputSlider] = React.useState(false); //true - Weight
    const [disableInput, setDisableInput] = React.useState(true); // Disable the slider
    const [disableOpSlider, setDisableOpSlider] = React.useState(true);

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');
    const[infoMsg, setInfoMsg] = React.useState('');

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.Density, densityBlend, densityTarget)
    },[ densityBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.FP, fpBlend, fpTarget)
    },[ fpBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.viscosity, visBlend, visTarget)
    },[ visBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.visTemp, visTempBlend, visTempTarget)
    },[ visTempBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.micCarResidue, mcBlend, mcTarget)
    },[ mcBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.ash, ashBlend, ashTarget)
    },[ ashBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.sodium, sodBlend, sodTarget)
    },[ sodBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.vanadium, vanBlend, vanTarget)
    },[ vanBlend]);

    useEffect(()=>{
        VerifyTargetConflictOnUpdate(parameter.Denaluminiumsity, aluBlend, aluTarget)
    },[ aluBlend]);

    const VerifyTargetConflictOnUpdate=(parameter, blend, target)=>{
        if (!(String(target) == '' || String(blend) == '')) {
            if (!meetsTarget(parameter, blend, target)) {
                showAdditionalInformation(InfoType.TargetConflict);
                return false;
            }
        }
    };

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const isFirstRun = useRef(false);
    useEffect(() => {
        if (!isFirstRun.current) {
            onCalcRadioBtnChange();
        }
    }, [outputSlider]);

    const isIpCalcFirstRun = useRef(false);
    useEffect(() => {
        if (!isIpCalcFirstRun.current) {
            onInCalcRadioBtnChange();
        }
    }, [inputSlider]);

    const parameter = {
        Density: 'Density',
        FP: 'Flash Point',
        viscosity: 'Viscosity',
        visTemp: 'Viscosity Temperature',
        micCarResidue: 'Micro Carbon Residue',
        sulphur: 'Sulphur',
        ash: 'Ash',
        vanadium: 'Vanadium',
        sodium: 'Sodium',
        aluminium: 'Aluminium + Silicon'
    }

    const decimal = {
        Density: 1,
        FP: 0,
        viscosity: 1,
        visTemp: 0,
        micCarResidue: 1,
        sulphur: 2,
        ash: 2,
        vanadium: 0,
        sodium: 0,
        aluminium: 0
    }


    const rows = [
        createData(parameter.Density, 'Kg / m3', 'densityFuel1', densityFuel1, 'densityFuel2', densityFuel2, 'densityTarget', densityTarget, 'densityBlend', densityBlend, decimal.Density),
        createData(parameter.FP, <label><sup>0</sup>C</label>, 'fpFuel1', fpFuel1, 'fpFuel2', fpFuel2, 'fpTarget', fpTarget, 'fpBlend', fpBlend, decimal.FP),
        createData(parameter.viscosity, 'mm2/s', 'visFuel1', visFuel1, 'visFuel2', visFuel2, 'visTarget', visTarget, 'visBlend', visBlend, decimal.viscosity),
        createData(parameter.visTemp, <label><sup>0</sup>C</label>, 'visTempFuel1', visTempFuel1, 'visTempFuel2', visTempFuel2, 'visTempTarget', visTempTarget, 'visTempBlend', visTempBlend, decimal.visTemp),
        createData(parameter.micCarResidue, '%m/m', 'mcFuel1', mcFuel1, 'mcFuel2', mcFuel2, 'mcTarget', mcTarget, 'mcBlend', mcBlend, decimal.micCarResidue),
        createData(parameter.sulphur, '%m/m', 'sulFuel1', sulFuel1, 'sulFuel2', sulFuel2, 'sulTarget', sulTarget, 'sulBlend', sulBlend, decimal.sulphur),
        createData(parameter.ash, '%m/m', 'ashFuel1', ashFuel1, 'ashFuel2', ashFuel2, 'ashTarget', ashTarget, 'ashBlend', ashBlend, decimal.ash),
        createData(parameter.vanadium, 'mg/kg', 'vanFuel1', vanFuel1, 'vanFuel2', vanFuel2, 'vanTarget', vanTarget, 'vanBlend', vanBlend, decimal.vanadium),
        createData(parameter.sodium, 'mg/kg', 'sodFuel1', sodFuel1, 'sodFuel2', sodFuel2, 'sodTarget', sodTarget, 'sodBlend', sodBlend, decimal.sodium),
        createData(parameter.aluminium, 'mg/kg', 'aluFuel1', aluFuel1, 'aluFuel2', aluFuel2, 'aluTarget', aluTarget, 'aluBlend', aluBlend, decimal.aluminium),
    ];

    const splitString = (value) => {
        return value.split(".");;
    }


    const addZeros = (value, noOfDigits)=>{
        return Number(value).toFixed(noOfDigits)
    }

    const restrictDecimals = (value, noOfDigits)=>{
        return value
            .toString()
            .split(".")
            .map((el, i) => i ? el.split("").slice(0, noOfDigits).join("") : el)
            .join(".");
    }

    const onTextChange = (value, name, param) => {

        if(value<1)
        {
            setInfoMsg(`${param} values should be Positive Numeric Values.`);
        }
       if(value == ""){
            setInfoMsg('');
        }
       
        setState(prevState => ({ ...prevState, [name]: value }));
    }

    const onFocusOut = (value, name, param) =>{
        const hasDecimal = value.includes(".");
        let noOfDecimalDigit = 0;
        if (hasDecimal) {
            noOfDecimalDigit = value.split(".")[1].length;
        }

        switch (param) {

            case parameter.FP:
            case parameter.visTemp:
            case parameter.vanadium:
            case parameter.sodium:
            case parameter.aluminium:
                {
                    // No decimals.
                    let result = value;
                    
                    if (hasDecimal)
                        // If has decimal digit, trucate the decimal portion.
                        result = Math.trunc(Number(value));

                    setState(prevState => ({ ...prevState, [name]: result }));
                    break;
                }

            case parameter.Density:
            case parameter.viscosity:
            case parameter.micCarResidue:
                {
                    // One decimal digit.
                    const NO_OF_DECIMAL_DIGIT = 1;
                    let result = value;

                    if (!hasDecimal)
                        // If no decimal digits add one zero decimal digit.
                        result = addZeros(value, NO_OF_DECIMAL_DIGIT);
                    else if (NO_OF_DECIMAL_DIGIT == noOfDecimalDigit)
                        // Has one decimal digit
                        result = value;
                    else
                        // More than one decimal digit
                        result = restrictDecimals(value, NO_OF_DECIMAL_DIGIT);

                    setState(prevState => ({ ...prevState, [name]: result }));

                    break;
                }

            case parameter.sulphur:
            case parameter.ash:
                {
                    // Two decimal digit.
                    const NO_OF_DECIMAL_DIGIT = 2;
                    let result = value;

                    if (!hasDecimal)
                        // If no decimal digits add two decimal digit
                        result = addZeros(value, NO_OF_DECIMAL_DIGIT);
                    else if (NO_OF_DECIMAL_DIGIT == noOfDecimalDigit)
                        // Has two decimal digit
                        result = value;
                    else
                        // More than two decimal digit
                        result = restrictDecimals(value, NO_OF_DECIMAL_DIGIT);

                    setState(prevState => ({ ...prevState, [name]: result }));
                    break;
                }
        }
    }

    const validateRow = (includeTarget, fuel1, fuel2, target,config) => {
        config = config || null;
        fuel1 = fuel1 != "" ? +fuel1 : "";
        fuel2 = fuel2 != "" ? +fuel2 : "";
        target = target != "" ? +target : "";

        if (fuel1 != "" && fuel2 != "") {
            if (includeTarget) {
                if (target == "") {
                    return false;
                }
                if ((target < fuel1 && target < fuel2) || (target > fuel1 && target > fuel2)) {
                    if (config) {
                        let message = config.Row == parameter.Density ?
                            `${config.Row} @15 C` :
                            `${config.Row}`;
                            config.errorMsg = message;
                    }
                    return false;
                }
                // else {
                //     setvalid("none")
                //     //setvalid()

                // }
            }
            return true;
        }
        return false;
    }

    const validateTemperatureRow = (includeTarget, config) => {
        let isValid = false;
        isValid = validateRow(includeTarget, visTempFuel1, visTempFuel2, visTempTarget, config);
        return isValid;
    }
    const onResetblend = () => {
        setState({ ...initialInputState })
        setFuelInput({ ...fuelInput, ...{ fuel1: "", fuel2: "" } })
        setFuelOutput({ ...fuelOutput, ...{ fuel1: "", fuel2: "" } })
        setInfoMsg('');
        setvalid('none');

    }
    const convertViscosity = (viscosity, temperature, targetTemperature) => {
        viscosity = +viscosity;
        temperature = +temperature;
        targetTemperature = +targetTemperature;

        let calculatedViscosity = "";
        if (temperature == targetTemperature)
            return viscosity;

        let FuelConstantA = FuelConstant.A;
        let FuelConstantB = FuelConstant.B;
        let ViscosityNo1 = viscosity;
        let ViscosityNo2 = "";
        let TemperatureNo1 = temperature;
        let TemperatureNo2 = targetTemperature;

        const config = {
            ViscosityNo1,
            TemperatureNo1,
            ViscosityNo2,
            TemperatureNo2
        };

        const constval = { FuelConstantA, FuelConstantB };
        calculatedViscosity = ViscosityCalculationService.CalculateViscosity(config, constval);
        return calculatedViscosity;
    }



    //#region Supporting functions    
    const GetPropertyType = (row) => {
        switch (row) {
            case parameter.Density:
                return PropertyType.Density;
            case parameter.FP:
                return PropertyType.FlashPoint;

            case parameter.viscosity:
                return PropertyType.Viscosity;
            default:
                return PropertyType.Proportional;
        }
    }

    const meetsTarget = (row, blendValue, target) => {

        // Convert string to float.
        blendValue = parseFloat(blendValue);
        target = parseFloat(target);

        if (row == parameter.FP) {
            if (blendValue < target && !Approximates(blendValue, target)) {
                return false;
            }
        }
        else {
            if (blendValue > target && !Approximates(blendValue, target)) {
                return false;
            }
        }
        return true;
    }

    const showAdditionalInformation = (Info, message="") => {

        let text = "As densities are not specified, ";
        // InformationLabel.ForeColor = Color.Blue
        switch (Info) {
            case InfoType.FlashPointRatioOnly:
                setInfoMsg(`${text} blend ratio is based on Flash Point target only.`);
            case InfoType.NoWeightValues:
                setInfoMsg(`${text} weight ratio based blend properties cannot be calculated.`);
            case InfoType.NoVolumeValues:
                setInfoMsg(`${text} Flash Point blend property cannot be calculated.`);
            case InfoType.TargetConflict: {
                // InformationLabel.ForeColor = Color.Red
                setInfoMsg("Two or more targets conflict. Calculated blend ratio can not satisfy all targets. Please check !");
            }
            case InfoType.TargetInvalid:
                setInfoMsg(`${message} target is invalid`);
        }
    }

    const ClearBlendValues = () => {
        let blend = {};
        rows.forEach((row) => {
            let blendName = row.BlendName;
            let blendValue = '';
            blend[blendName] = blendValue;
        });

        setState((prevState) => ({ ...prevState, ...blend }));
    };

    const GetBlendPropertyValues = (ratio, ratioType, criticalParameter = -1) => {


        ClearBlendValues() // TODO: Need to imol

        let density1 = ""
        let density2 = ""
        let densityGiven = false
        let validTemperatures = false;
        let viscosityBlendValue = "", viscosityTempBlendValue = "";

        rows.forEach(row => {
            if (validateRow(false, row.Fuel1, row.Fuel2, row.Target)) {
                let blend = new Blending()
                blend.ComponentRatio = ratio
                blend.ComponentRatioType = ratioType
                blend.ComponentPropertyType = GetPropertyType(row.Parameter) // need to check wh

                let value1 = row.Fuel1;
                let value2 = row.Fuel2;

                if (row.Parameter == parameter.Density) {
                    density1 = value1
                    density2 = value2
                    densityGiven = true
                }
                else if (row.Parameter == parameter.viscosity) {
                    // Check for valid temperature entries
                    validTemperatures = validateTemperatureRow(false)
                    if (validTemperatures) {
                        // Convert Viscosity to standard temperature of 50C
                        value1 = convertViscosity(value1, visTempFuel1, "50")
                        value2 = convertViscosity(value2, visTempFuel2, "50")
                    }
                }
                
                if (row.Parameter == parameter.visTemp) {
                    
                    if (!(viscosityBlendValue == "")) {
                            viscosityTempBlendValue = MathFormula.roundAccurately(visTempTarget, row.decimalPts);
                            setState(prevState => ({ ...prevState, visTempBlend: viscosityTempBlendValue }));
                        if (!viscosityTempBlendValue) {
                            setState(prevState => ({ ...prevState, visTempBlend: MathFormula.roundAccurately(visTempFuel1, row.decimalPts) }));
                        }
                    }
                }
                else if (row.Parameter == parameter.viscosity && !validTemperatures) {//|| .ActiveRowIndex = GridRow.Ratio 
                    // Do nothing
                }
                else {
                    if (densityGiven) {
                        blend.Component1_Density = density1
                        blend.Component2_Density = density2
                    }
                    
                    blend.Component1_Property = value1
                    blend.Component2_Property = value2
                    if (blend.GetBlendPropertyValue()) {
                        if (row.Parameter == parameter.viscosity) {
                            //Convert BlendViscValue to Viscosity Target Temperature or Fuel1 Temperature
                            let target = ""
                            if (!visTempTarget == "")
                                target = visTempTarget;
                            else
                                target = visTempFuel1;
                            let blendValue = convertViscosity(blend.BlendProperty, "50", target);
                            let blendName = row.BlendName;
                            viscosityBlendValue = blendValue;
                            setState(prevState => ({ ...prevState, [blendName]: MathFormula.roundAccurately(blendValue, row.decimalPts) }));
                        }
                        else {
                            let blendName = row.BlendName;
                            let blendValue = '';
                            if (blend.BlendProperty > 0) {
                                blendValue = MathFormula.roundAccurately(blend.BlendProperty, 2);
                            }
                            const blendvalue = blend.BlendProperty;
                            setState(prevState => ({ ...prevState, [blendName]: MathFormula.roundAccurately(blendValue, row.decimalPts) }));
                        }
                    }

                    // if (criticalParameter > -1 && .ActiveRowIndex = criticalParameter )
                    //     .Cells(.ActiveRowIndex, GridColumn.Blend).ForeColor = Color.Red
                    // End if}
                    else {
                        if (!densityGiven) {
                            if (blend.BlendRatioType == RatioType.weight)
                                if (blend.ComponentPropertyType == PropertyType.FlashPoint)
                                    showAdditionalInformation(InfoType.NoVolumeValues)
                                else if (blend.BlendRatioType == RatioType.weight)
                                    showAdditionalInformation(InfoType.NoWeightValues)
                        }
                    }
                }
            }
        });
        
    }


    const calculate = (config, includeTarget, fuel1, fuel2, targetValue) => {
        if (validateRow(false, fuel1, fuel2, targetValue)
            && config.Row != parameter.visTemp) {
            let blend = new Blending();
            let value1 = fuel1;
            let value2 = fuel2;

            if (config.Row == parameter.Density) {
                config.density1 = value1;
                config.density2 = value2;
                config.densityGiven = true;
            }
            else if (config.Row == parameter.FP
                && !config.densityGiven) {
                config.FlashPointOnly = true;
            }

            else if (config.Row == parameter.viscosity) {
                
                config.validTemperatures = validateTemperatureRow(true,config);
                if (config.validTemperatures) {
                    value1 = convertViscosity(value1, visTempFuel1, "50");
                    value2 = convertViscosity(value2, visTempFuel2, "50");
                }
            }

            if (config.densityGiven) {
                blend.Component1_Density = config.density1;
                blend.Component2_Density = config.density2;
            }

            if (config.Row == parameter.viscosity && !config.validTemperatures) {
                // InformationLabel.Text = "Viscosity target not used due to missing temperature"
            }
            else if (validateRow(true, fuel1, fuel2, targetValue, config)
                && config.Row != parameter.visTemp) {
                let target = targetValue;
                if (config.Row == parameter.viscosity) {
                    
                    target = convertViscosity(target, visTempTarget, "50");
                }
                blend.Component1_Property = value1;
                
                blend.Component2_Property = value2;
                blend.BlendPropertyTarget = target;
                blend.ComponentPropertyType = GetPropertyType(config.Row);

                // TODO: null or "" check
                if (config.bestRatio != null) {
                    let blendValue = "";
                    blend.ComponentRatio = config.bestRatio;
                    blend.ComponentRatioType = RatioType.weight;
                    if (blend.GetBlendPropertyValue()) {
                        blendValue = blend.BlendProperty;
                        
                        if (!meetsTarget(config.Row, blendValue, target)) {
                            config.bestRatio = null;
                        }
                    }
                }
                
                if (config.bestRatio == null) {
                    if (config.FlashPointOnly) {
                        if (blend.GetBlendRatio(RatioType.volume)) {
                            config.bestRatio = blend.BlendRatio;
                            config.bestRatioType = blend.BlendRatioType;
                            config.criticalParameter = parameter.FP;
                            showAdditionalInformation(InfoType.FlashPointRatioOnly);
                         }
                    }
                    else {
                        if (blend.GetBlendRatio(RatioType.weight)) {
                            config.bestRatio = blend.BlendRatio;
                            config.bestRatioType = blend.BlendRatioType;
                            //TODO: Need to check assignment
                            // config.criticalParameter = ;
                        }
                    }
                }
                if (blend.Information != "") {
                    config.info = blend.Information;
                }
                if (blend.Exception) {
                    // TODO: Show exception.
                }
            }

        }

    };

    const UpdateBlendRatioRowData = () => {
        //     if (calcFields == "blend-targets"){
        //     .Cells(GridRow.Ratio, GridColumn.Parameter).Text = "Calc. Blend Ratio"
        //     .Cells(GridRow.Ratio, GridColumn.Parameter).Tag = "TARGET"}
        //     if CalcVolumePctRadioButton.Checked Then
        //         .Cells(GridRow.Ratio, GridColumn.Unit).Text = "%V/V"
        //     Else
        //         .Cells(GridRow.Ratio, GridColumn.Unit).Text = "%m/m"
        //     End if
        //     .Cells(GridRow.Ratio, GridColumn.Fuel1).Text = CalcFuel1PctTextBox.Text
        //     .Cells(GridRow.Ratio, GridColumn.Fuel2).Text = CalcFuel2PctTextBox.Text
        // Else
        //     .Cells(GridRow.Ratio, GridColumn.Parameter).Text = "Set Blend Ratio"
        //     .Cells(GridRow.Ratio, GridColumn.Parameter).Tag = "SET"
        //     if SetVolumePctRadioButton.Checked Then
        //         .Cells(GridRow.Ratio, GridColumn.Unit).Text = "%V/V"
        //     Else
        //         .Cells(GridRow.Ratio, GridColumn.Unit).Text = "%m/m"
        //     End if
        //     .Cells(GridRow.Ratio, GridColumn.Fuel1).Text = SetFuel1PctNumTextBox.Text
        //     .Cells(GridRow.Ratio, GridColumn.Fuel2).Text = SetFuel2PctNumTextBox.Text
        // End if
    };

    // const VerifyTargetConflict = () => {
    //     
    //     rows.every(row => {
    //         if (!(String(row.Target) == '' || String(row.Blend) == '')) {
    //             if (!meetsTarget(row.Parameter, row.Blend, row.Target)) {
    //                 showAdditionalInformation(InfoType.TargetConflict);
    //                 setrate("block")
    //                 return false;
    //             }
    //         }
    //         return true;
    //     });
    // };


    //#endregion

    // On calcualte button click.
    const onCalcHandle = () => {
        
        // To reset if any info message is displayed.
        setInfoMsg('');

        let { fuel1, fuel2 } = fuelInput;
        const weightSelected = inputSlider;
        const volumeSelected = !inputSlider;

        try {
            if (calcFields.calcmethod == "blend-targets") {
                let bestRatio = null;
                let bestRatioType=RatioType;
                let criticalParameter = -1;
                let FlashPointOnly = false;
                let density1 = "";
                let density2 = "";
                let densityGiven = false;
                let info = "";
                let validTemperatures = false;
                let errorMsg = "";

                const config = {
                    density1,
                    density2,
                    densityGiven,
                    FlashPointOnly,
                    validTemperatures,
                    bestRatio,
                    bestRatioType,
                    criticalParameter,
                    errorMsg
                };

                rows.forEach(row => {
                    config["Row"] = row.Parameter;
                    calculate(config, false, row.Fuel1, row.Fuel2, row.Target);
                });

                if(config.errorMsg)
                    showAdditionalInformation(InfoType.TargetInvalid, config.errorMsg);

                if (config.bestRatio != null) {
                    if (config.bestRatioType == RatioType.weight) {
                        // TODO: Enalbe/disable radio button.
                        //Enable weight
                    }
                    else {
                        // Enable volume
                    }

                    let calculatedFuel1 = config.bestRatio.A * 100;
                    let calculatedFuel2 = config.bestRatio.B * 100;
                    
                    // Volume ratio.
                    let ratio = new Ratio(calculatedFuel1, calculatedFuel2, true);
                    let blend = new Blending();
                    let volRatio = new Ratio();
                    volRatio = blend.GetVolumeRatio(ratio, densityFuel1, densityFuel2);
                    calculatedFuel1 = volRatio.A * 100;
                    calculatedFuel2 = volRatio.B * 100;
                    
                    setFuelOutput(prevState => ({ ...prevState, fuel1: calculatedFuel1, fuel2: calculatedFuel2 }));
                    GetBlendPropertyValues(config.bestRatio, config.bestRatioType, config.criticalParameter);
                    UpdateBlendRatioRowData(); // TODO: Need to implement
                    //VerifyTargetConflict(); // TODO: Need to implement
                }
            }
            else {
                onInCalcRadioBtnChange();
                // // Check whether weight or vol is selected
                // if (fuel1.toString().length > 0 && fuel2.toString().length > 0
                //     && (volumeSelected || weightSelected)) {
                //     let fixedRatio = new Ratio(fuel1, fuel2, true);
                //     if (volumeSelected) {
                //         GetBlendPropertyValues(fixedRatio, RatioType.volume)
                //     }
                //     else {
                //         GetBlendPropertyValues(fixedRatio, RatioType.weight)
                //     }

                //     UpdateBlendRatioRowData()
                // }
                // else {
                //     // ErrorProvider.SetError(SetWeightPctRadioButton, "Please provide all required information")
                // }
            }
        }
        catch (ex) {
            // alert(`densityFuel1 - ${densityFuel1} densityFuel2 - ${densityFuel2}`);
        }
    };

    // On radio button value changes.
    const onValuesChange = (value, field) => {
        let local = calcFields;
        local[field] = value;
        setCalcFields({ ...calcFields, ...local });
        setDisableInput((prevState) => !prevState)
    }

    // When fuel input changes.
    const onFuelInputUpdate = (value, field) => {
        setFuelInput((prevState) => ({ ...prevState, [field]: value }));
        ClearBlendValues();
    }

    const onOutputFuelUpdate = (value, field) => {
        setFuelOutput((prevState) => ({ ...prevState, [field]: value }));
    }

    // Toggle the slider.
    const onIpSliderChange = () => {
        if (isIpCalcFirstRun.current)
            isIpCalcFirstRun.current = true;
        setInputSlider((prevState) => !prevState);
    }

    const onOpSliderChange = () => {
        if (isFirstRun.current)
            isFirstRun.current = true;
        setOutputSlider((prevState) => !prevState);
    }

    function onCalcRadioBtnChange() {
        
        if (fuelOutput.fuel1 == "" || fuelOutput.fuel2 == "") {
            return;
        }

        let value1 = densityFuel1;
        let value2 = densityFuel2;
        let ratio = new Ratio(fuelOutput.fuel1, fuelOutput.fuel2, true);
        let blend = new Blending();
        let newRatio = new Ratio();
        if (outputSlider) {
            newRatio = blend.GetWeightRatio(ratio, value1, value2);
        }
        else {
            newRatio = blend.GetVolumeRatio(ratio, value1, value2);
        }

        let CalcFuel1 = newRatio.A * 100;
        let CalcFuel2 = newRatio.B * 100;
        //console.log("869-before:", fuelOutput);
        setFuelOutput(prevState => ({ ...prevState, fuel1: CalcFuel1, fuel2: CalcFuel2 }));
        //console.log("869-before:", fuelOutput);
        UpdateBlendRatioRowData(); //TODO:

    }

    /* function inValidTarget(value){
        //
        let msg=""
        if(value.Density=="Density" ){
            msg="Density"
        }
        else if (value.FP=="FlashPoint"){
            msg="FlashPoint"
        }
        return `${msg} Target is Invalid`
    }  */

    function onInCalcRadioBtnChange() {

        let { fuel1, fuel2 } = fuelInput;
        const weightSelected = inputSlider;
        const volumeSelected = !inputSlider;

        // Check whether weight or vol is selected
        if (fuel1.toString().length > 0 && fuel2.toString().length > 0
            && (volumeSelected || weightSelected)) {
            let fixedRatio = new Ratio(fuel1, fuel2, true);
            if (volumeSelected) {
                GetBlendPropertyValues(fixedRatio, RatioType.volume)
            }
            else {
                GetBlendPropertyValues(fixedRatio, RatioType.weight)
            }

            UpdateBlendRatioRowData()
        }
        else {
            // ErrorProvider.SetError(SetWeightPctRadioButton, "Please provide all required information")
        }

    }
    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Blend Calculation</span>

                </div>

                <Box component="div" className="filtercontainer">
                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Blend Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>This module performs blend Calculations. You can calculate a blend ratio based on a required blend target (e.g. Flash Point minimum 62°C or Viscosity max 14 mm2/s, see eample 1) or determine the properties of a blend based on the fuel properties and ratio's used to produce the blend (see example 2).

                                        </p>
                                        <p className="subtitle">Example 1 - Calculation of a blend ratio based on a required target</p>

                                        <img className="maxwidth100" src="/assets/images/Blend-Calculation-1.jpg"></img>
                                        <p><b>Note:</b> If you enter the Density of both fuels, you can calculate the blend ratio in either volume% or weight%. The fuel densities are also important to determine the critical parameter when specifying multiple targets as shown above. This applies especially if one of the blend targets is Flash Point. In the example above, Sulphur is the critical parameter (marked in red).</p>
                                        <p className="subtitle">Example 2 - Calculation of the blend properties based on a set blend ratio</p>
                                        <img className="maxwidth100" src="/assets/images/Blend-Calculation-2.jpg"></img>
                                        <p><b>Note: </b>If you enter the density of both fuels, you can calculate the ratio in either volume% or weight%.</p>


                                        <p>Flash Point: If you enter multiple targets of which one target concersn Flash Point you should be aware of the following:
                                        </p>
                                        <ul>
                                            <li>If you do not specify the densities of the blend components, ONLY Flash Point will be used in determining the blend ratio to meet the target.
                                            </li>
                                            <li>There may be cases where the Flash Point targer conflicts with the other targets (see example 3).
                                            </li>

                                        </ul>
                                        <p className="subtitle">Example 3 - Two blend targets causing a conflict</p>
                                        <img className="maxwidth100" src="/assets/images/blend-3.jpg"></img>
                                        

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>
                    <Box component="div">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <p className="subtitle">Calculation Mode</p>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6}>

                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="position" name="position" onChange={(e) => onValuesChange(e.target.value, "calcmethod")} defaultValue="left">
                                        <FormControlLabel className="mb0" value="blend-targets" control={<Radio />} label="Calculate a blend ratio based on specified blend targets" checked={!calcFields.calcmethod ? true : calcFields.calcmethod === "blend-targets" ? true : false} />
                                        <FormControlLabel className="mb0" value="blend-ratio" control={<Radio />} label="Calculate blend properties based on a specified blend ratio" />

                                    </RadioGroup>
                                </FormControl>

                                {/* input */}
                                <Grid container spacing={24} >
                                    <Grid item xs={12} md={6} className="padbt">
                                        <BlendCalculationMode fuelInput={fuelInput} setFuelInput={onFuelInputUpdate} disableFuelInput={disableInput} />

                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbt">

                                        <Box component="span" className="blendpading" >
                                            <Blend_Switches disableSlider={disableInput} toggleSlider={onIpSliderChange} ischecked={inputSlider} />

                                        </Box>


                                    </Grid>
                                </Grid>


                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={5}>

                                <Box component="div" className="resultbox blendresultbox">
                                    <p>Results</p>
                                    <Box component="div" className="bunkarinput resultinner">

                                        <form className={classes.root} noValidate autoComplete="off">
                                            <Box component="div" className="padbtm25 bluendcalc">
                                                <label className="resultLabel">Calculated Blend Ratio  </label>

                                                <Blend_Switches disableSlider={!disableInput} toggleSlider={onOpSliderChange} ischecked={outputSlider} />
                                                <br></br>

                                                <Blend_slider fuelOutput={fuelOutput} />

                                            </Box>

                                        </form>
                                    </Box>



                                </Box>
                            </Grid>


                            <Grid item xs={12} sm={12} md={12}>

                                <Box component="div" className="pr30">

                                    <TableContainer component={Paper} c  >
                                        <Table aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Fuel Parameter</StyledTableCell>
                                                    <StyledTableCell >Unit</StyledTableCell>
                                                    <StyledTableCell >Fuel 1</StyledTableCell>
                                                    <StyledTableCell >Fuel 2</StyledTableCell>
                                                    <StyledTableCell >Target</StyledTableCell>
                                                    <StyledTableCell >Blend</StyledTableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row, idx) => (
                                                    <StyledTableRow key={row.name}>
                                                        <StyledTableCell component="th" scope="row">
                                                            {row.Parameter}
                                                        </StyledTableCell>
                                                        <StyledTableCell  >{row.Unit}</StyledTableCell>
                                                        <StyledTableCell  >
                                                            <BootstrapInput
                                                                onChange={(e) => onTextChange(e.target.value, row.Fuel1Name,
                                                                    row.Parameter)}
                                                                onBlur={(e)=>onFocusOut(e.target.value, row.Fuel1Name,
                                                                    row.Parameter)}
                                                                value={row.Fuel1}
                                                                type="number"
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell  >
                                                            <BootstrapInput
                                                                onChange={(e) => onTextChange(e.target.value, row.Fuel2Name,
                                                                    row.Parameter)}
                                                                onBlur={(e)=>onFocusOut(e.target.value, row.Fuel2Name,
                                                                    row.Parameter)}
                                                                value={row.Fuel2}
                                                                type="number"
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell  >
                                                            <BootstrapInput
                                                                onChange={(e) => onTextChange(e.target.value, row.TargetName,
                                                                    row.Parameter)}
                                                                onBlur={(e)=>onFocusOut(e.target.value, row.TargetName,
                                                                    row.Parameter)}
                                                                value={row.Target}
                                                                type="number"
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell  >
                                                            <BootstrapInput
                                                                value={row.Blend}
                                                                disabled />
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>

                            </Grid>
                        </Grid>

                    </Box>





                    <br></br>
                    <Grid container spacing={3} className="mt25">




                        <Grid item xs={12} sm={12} md={12} className="mb25 mt25">
                            <span style={{ color: "red", display: "block", marginLeft: "450px", fontSize: "20px" }}>{infoMsg} </span>
                            {/*  <span  style={{color: "red",display:valid,marginLeft:"450px",fontSize:"20px"}}>Invalid Target! </span>  */}
                            <button type="reset" className={classes.btn1} onClick={onResetblend}  >Reset</button>
                            <button type="button" className={classes.btn2} onClick={onCalcHandle} >Calculate</button>

                            {''}

                        </Grid>
                    </Grid>

                </Box>








            </div>
        </div>
    );
}
export default BlendCalculation;
